import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import EmploymentIntensityViewModel from '../ViewModels/EmploymentIntensityViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IEmploymentIntensityDropDownProps {
    setEmploymentIntensity?: (event) => void;
    employmentIntensity: string | undefined;
    disabled: boolean;
}

interface IEmploymentIntensityDropDownState {
    model: EmploymentIntensityViewModel[];
    loaded: boolean;
}

class EmploymentIntensityDropDown extends Component<IEmploymentIntensityDropDownProps & WithStyles<typeof styles>, IEmploymentIntensityDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetEmploymentIntensities').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultEmploymentIntensityVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="How many hours per week were you working/do you work?"
                name="employmentIntensity"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.employmentIntensity}
                onChange={this.props.disabled ? undefined : this.props.setEmploymentIntensity}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(EmploymentIntensityDropDown);